import { render, staticRenderFns } from "./fenge.vue?vue&type=template&id=2828f52a&"
import script from "./fenge.vue?vue&type=script&lang=ts&"
export * from "./fenge.vue?vue&type=script&lang=ts&"
import style0 from "./fenge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports